import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const VendorManagementViewChunk = React.lazy(() =>
  import('../feature-sets/VendorManagementView').then(
    ({ VendorManagementView }) => ({
      default: VendorManagementView,
    })
  )
)

export const VendorManagementPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.vendorManagementPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.vendorManagementPageTitle),
        },
      ]}
    >
      <VendorManagementViewChunk />
    </Page>
  )
}
